// extracted by mini-css-extract-plugin
export default {"wrapperBig":"limited-edition-in-stock__wrapperBig___rG8zU","wrapperFullWidth":"limited-edition-in-stock__wrapperFullWidth___XCu2E"};